import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	resetButton,
	resetFirstMarginTop,
	resetLastMarginBottom,
	outlineA11y,
} from '@/css/resources/placeholders.css';
import {
	fontStyle,
	fluidBorderRadius,
	fluidBorderWidth,
	fluidPadding,
	expandLink,
} from '@/css/resources/mixins.css';
import {
	wrapperStyles,
	inputSizeStyles,
	inputSizeEditStyles,
	optionalStyles,
} from '@/css/shared/inputs.css';
import { transitions } from '@/css/resources/variables.css';

const getDynamicStyles = (formStyles) =>
	css(wrapperStyles(formStyles), inputSizeStyles(), {
		'.supt-inputFile__inner': cssObj(
			fluidPadding(formStyles?.file?.padding),
			fluidBorderWidth(formStyles?.file?.border?.width),
			fluidBorderRadius(formStyles?.file?.border?.radius),
			{
				background: formStyles?.file?.backgroundColor,
				borderColor: formStyles?.file?.border?.color,
			}
		),

		'.supt-inputFile__title-wrap': {
			svg: {
				fill: formStyles?.file?.icon?.color,
			},
		},

		'.supt-inputFile__title': cssObj(
			fontStyle({
				...formStyles?.file?.title?.typography,
				textAlign: formStyles?.file?.title?.textAlignment,
				color: formStyles?.file?.title?.color,
			}),
			optionalStyles(formStyles)
		),

		'.supt-inputFile__description': fontStyle({
			...formStyles?.file?.description?.typography,
			textAlign: formStyles?.file?.description?.textAlignment,
			color: formStyles?.file?.description?.color,
		}),

		'.supt-inputFile__list': fontStyle({
			...formStyles?.file?.list?.typography,
			textAlign: formStyles?.file?.list?.textAlignment,
			color: formStyles?.file?.list?.color,
		}),

		'.supt-inputFile__file': {
			'.supt-inputFile__file__delete': {
				svg: {
					fill: formStyles?.file?.list?.color,
				},

				'&:hover': {
					svg: {
						backgroundColor: formStyles?.file?.list?.color,
						fill: '#fff',
					},
				},
			},
		},

		'.supt-inputFile__label': fontStyle({
			...formStyles?.file?.link?.typography,
			textAlign: formStyles?.file?.link?.textAlignment,
			color: formStyles?.file?.link?.color,
		}),

		'&.supt-inputField--error': {
			'.supt-inputFile__inner': {
				borderColor: formStyles.error?.color,
			},

			'.supt-inputFile__title, .supt-inputFile__description': {
				color: formStyles.error?.color,
			},

			'.supt-inputFile__title-wrap': {
				svg: {
					fill: formStyles.error?.color,
				},
			},
		},
	});

const getStyles = (formStyles) =>
	css(getDynamicStyles(formStyles), {
		'.supt-inputFile__inner': cssObj(expandLink('label'), {
			borderStyle: 'solid',
			display: 'flex',
			flexDirection: 'column',
			height: '100%',
		}),

		'.supt-inputFile__title-wrap': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			width: '100%',
		},

		'.supt-inputFile__title': cssObj(resetFirstMarginTop, {
			display: 'flex',
		}),

		'.supt-inputFile__list': cssObj(resetFirstMarginTop, {
			listStyle: 'none',
		}),

		'.supt-inputFile__file': {
			'.supt-inputFile__file__delete': cssObj(resetButton, {
				position: 'relative',
				display: 'flex',
				alignItems: 'center',
				zIndex: 2,
				cursor: 'pointer',
				paddingRight: 40,
				lineHeight: 'inherit',
				fontSize: 'inherit',
			}),

			span: {
				flexGrow: 1,
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
			},

			svg: {
				position: 'absolute',
				top: '50%',
				right: 0,
				padding: 9,
				width: '29px',
				height: '29px',
				transform: 'translateY(-50%)',
				borderRadius: '50%',
				transition: `background ${transitions.mid} ease-out`,
			},

			'&:hover': {
				span: {
					textDecoration: 'underline',
				},
			},
		},

		'.supt-inputFile__description': resetFirstMarginTop,

		'.supt-inputFile__labelWrapper': {
			display: 'flex',
			marginTop: 'auto',
		},

		'.supt-inputFile__label': cssObj(resetLastMarginBottom, {
			cursor: 'pointer',

			'&--disabled': {
				pointerEvents: 'none',
				opacity: '0.5',
			},
		}),

		'.supt-inputFile__input': {
			position: 'absolute',
			bottom: '0',
			opacity: '0 !important',
			padding: '0',
			outline: 'none',

			'html:not(.using-mouse) &:focus-within ~ .supt-inputFile__label':
				outlineA11y,
		},
	});

// edit
// const getEditStyles = (formStyles) =>
// 	css({
// 	});

const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/input-file"]': inputSizeEditStyles(),
	});

export { getStyles, getEditGlobalStyles };
